module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-search-entity",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "keydown": _vm.showChar,
      "keyup": _vm.showChar
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "m-0",
    class: {
      'noborder': _vm.showResults && !_vm.loading
    },
    attrs: {
      "type": "text",
      "placeholder": ("Search " + _vm.entity)
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, _vm.debouncedSearch],
      "focusout": _vm.handleFocusout,
      "focusin": _vm.handleFocusIn
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('loading-spinner', {
    attrs: {
      "height": "30px"
    }
  })], 1) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "results",
    class: {
      'open': _vm.showResults, 'scroll': _vm.results.length > 6
    },
    attrs: {
      "tabindex": "1"
    }
  }, [_vm._l((_vm.results), function(result) {
    return (_vm.results.length && _vm.showResults) ? _c('div', {
      key: result.id,
      staticClass: "result",
      class: {
        'selected': result.id === _vm.selected
      },
      on: {
        "click": function($event) {
          return _vm.select($event, result)
        }
      }
    }, [_vm._t("default", [_c('div', [_c('small', [_vm._v(_vm._s(_vm.prefix) + _vm._s(result.id))]), _c('div', [_vm._v(_vm._s(result.name) + " " + _vm._s(result.surname))])])], {
      "result": result
    })], 2) : _vm._e()
  }), (!_vm.results.length && _vm.showResults) ? _c('div', {
    staticClass: "no-results"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v("No results")])]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f04e5596!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/SearchEntity.vue
// module id = 2746
// module chunks = 1